import { ref, uploadBytesResumable, getDownloadURL, deleteObject } from "firebase/storage";
import useFirebaseConfig from "./useFirebaseConfig";

const useStorage = () => {
  const { storage } = useFirebaseConfig();

  const extractFileNameFromUrl = (url) => {
    // URL에서 파일 경로 부분을 추출합니다.
    const match = url.match(/\/o\/([^?]+)/);
    if (match) {
      // 파일 경로를 디코딩합니다.
      const filePath = decodeURIComponent(match[1]);
      // 파일 이름을 추출합니다.
      const fileName = filePath.split('/').pop();
      return fileName || null;
    }
    return null;
  };

  async function uploadStorage(table, file, setProgress) {
    const storageRef = ref(storage, `${table}/${file.name}`);
    const uploadTask = uploadBytesResumable(storageRef, file);
    const promise = new Promise((resolve, reject) => {
      uploadTask.on(
        "state_changed",
        (snapshot) => {
          // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
          const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          if (typeof setProgress === 'function') {
            setProgress(progress);
          }
        },
        (error) => {
          // A full list of error codes is available at
          // https://firebase.google.com/docs/storage/web/handle-errors
          switch (error.code) {
            case "storage/unauthorized":
              reject("storage/unauthorized");
              // User doesn't have permission to access the object
              break;
            case "storage/canceled":
              reject("storage/canceled");
              // User canceled the upload
              break;
            case "storage/unknown":
              reject("storage/unknown");
              // Unknown error occurred, inspect error.serverResponse
              break;
            default:
              break;
          }
        },
        () => {
          // Upload completed successfully, now we can get the download URL
          getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
            resolve(downloadURL);
          });
        }
      );
    });
    return promise;
  }
  const fetchBlobFromUrl = async (blobUrl) => {
    const response = await fetch(blobUrl);
    const blob = await response.blob();
    return blob;
  };

  const blobToFile = (blob, fileName) => {
    return new File([blob], fileName, { type: blob.type });
  }

  const uploadBlobUrlToStorage = async (table, fileName, blobUrl, setProgress) => {
    try {
      const blob = await fetchBlobFromUrl(blobUrl);
      const file = blobToFile(blob, fileName);
      const downloadURL = await uploadStorage(table, file, setProgress);
      return downloadURL;
    } catch (error) {
      console.error('Error uploading Blob URL to Firebase Storage:', error);
      throw error;
    }
  };

  const deleteStorage = async (path, fileUrl) => {
    if (!path || !fileUrl) {
      return false;
    }
    const fileName = extractFileNameFromUrl(fileUrl);
    if (!fileName) {
      console.error("Failed to extract file name from URL");
      return false;
    }
    const fileRef = ref(storage, `${path}/${fileName}`);
    try {
      await deleteObject(fileRef);
      console.log(`File ${fileName} deleted successfully`);
      return true;
    } catch (err) {
      console.error("Error deleting file:", err);
      return false;
    }
  };

  return {
    uploadStorage,
    deleteStorage,
    uploadBlobUrlToStorage
  };
};

export default useStorage;
